import { FilterAdapter } from 'app/components/filters/url-filters';
import { CalendarDateRange } from 'app/console-api/statistics/types';
import { addDaysUTC, parseYMD, todayUTC, toYMD } from 'app/components/utils/date-time';

export const defaultRange = (): CalendarDateRange => {
  const to = todayUTC();
  const from = addDaysUTC(to, -30);
  return { from, to };
};

export const DateRangeFilterAdapter: FilterAdapter<CalendarDateRange> = {
  key: 'date',
  fromUrl: (sp) => {
    const fStr = sp.get('from') || '';
    const tStr = sp.get('to') || '';
    if (fStr && tStr) {
      return { from: parseYMD(fStr), to: parseYMD(tStr) };
    }
    return defaultRange();
  },
  toUrl: (sp, value) => {
    const r = value ?? defaultRange();
    const next = new URLSearchParams(sp.toString());
    next.set('from', toYMD(r.from));
    next.set('to', toYMD(r.to));
    return next;
  },
  toKey: (v) => (v ? `${toYMD(v.from)}_${toYMD(v.to)}` : '')
};
